var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmericanexpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "maestro-color",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "card_bg",
    width: 24,
    height: 16,
    rx: 2,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "maestro",
    transform: "translate(2.32 1.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 19.35,
    height: 12.8,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    width: 5.11,
    height: 8.34,
    transform: "translate(7.13 2.23)",
    fill: "#7272b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M6.571,5.3a5.31,5.31,0,0,1,2-4.17,5.3,5.3,0,1,0,0,8.34A5.29,5.29,0,0,1,6.571,5.3Z",
    transform: "translate(1.109 1.1)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M.5.585V.415H.425v.17Z",
    transform: "translate(17.255 9.105)",
    fill: "#00a1de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M.615.605V.4H.565L.5.545.445.4H.385v.21h0V.445l.06.13h0L.5.445v.16Z",
    transform: "translate(17.475 9.086)",
    fill: "#00a1de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M8.58,5.307A5.31,5.31,0,0,1,0,9.477a5.31,5.31,0,0,0,2.023-4.17A5.31,5.31,0,0,0,0,1.137a5.3,5.3,0,0,1,8.58,4.17Z",
    transform: "translate(9.68 1.093)",
    fill: "#00a1de"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanexpress);
export default __webpack_public_path__ + "static/media/americanexpress.da7f33d8e4a8156f8e271af65d745439.svg";
export { ForwardRef as ReactComponent };